<template>
  <base-section id="block-features">
    <base-section-heading
      color="grey lighten-2"
      title="Наши преимущества"
      id="features"
    />
    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="3"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionBlockFeatures',

    data: () => ({
      cards: [
        {
          title: 'Экология',
          subtitle: '',
          text: 'Мы заботимся как о природе, так и о вашем комфорте. При строительстве применены самые экологичные технологии.\n' +
            'Комфортный микроклимат.\n' +
            'Бизнес-центр оснащен системой климат-контроля, вы можете поддерживать нужный уровень температуры, влажности и вентиляции.',
          callout: '01',
        },
        {
          title: 'Интеллектуальное освещение',
          subtitle: '',
          text: 'Интеллектуальная система поддерживает уровень освещённости по вашему предпочтению. Параметры света в офисе не зависят от внешних факторов. ',
          callout: '02',
        },
        {
          title: 'Скорость и экономия времени',
          subtitle: '',
          text: 'Бизнес-центр оснащен высокоскоростными лифтами LG, которые автоматически управляют пассажиропотоком. Вы никого не ждёте и никуда не опаздываете.',
          callout: '03',
        },
        {
          title: 'Чистота и защита',
          subtitle: '',
          text: 'Главным нашим приоритетом является здоровье и безопасность арендаторов.\n' +
            'Мы работаем совместно с командой эпидемиологов для обеспечения санитарно-эпидемиологического благополучия в соответствии с законодательством РК.\n' +
            'Имеем мобильный инвентарь, автоматическое оборудование и препараты профессиональной химии для клинига.',
          callout: '04',
        },
      ],
    }),
  }
</script>
